module.exports = "/fonts/ebilling-logotype-l-e7a5642ec62456040967600f6bd54eea.svg";